export const formatPrice = (price, currency = 'GBP') => {
  const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency,
  });

  return currencyFormatter.format(parseFloat(price));
};
